import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output
} from '@angular/core';

@Directive({
  selector: '[observeVisibility]'
})
export class ObserveVisibilityDirective implements AfterViewInit, OnDestroy {
  @Output() onVisible = new EventEmitter<boolean>();
  @Input() scrollableContainer: HTMLDivElement;

  private observer!: IntersectionObserver;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.onVisible.emit(entry.isIntersecting); // true = visible
      },
      {
        root: this.scrollableContainer, // scrollable container
        threshold: 0.1 // trigger when at least 10% is visible
      }
    );

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    this.observer.disconnect();
  }
}
